(() => {
  const body = document.body;
  const productRoutes = { add: '/cart/add.js', change: '/cart/change.js', cart: '/cart' };
  let cartDrawer = document.querySelector('[data-cart-drawer]');
  const searchDialog = document.querySelector('[data-search-dialog]');
  const cartCount = () => document.querySelectorAll('[data-cart-count]');
  const cartTriggers = () => document.querySelectorAll('[data-cart-open]');
  const menuTriggers = () => document.querySelectorAll('[data-menu-open]');
  const searchTriggers = () => document.querySelectorAll('[data-search-open]');
  const panelIsOpen = panel => Boolean(panel?.classList.contains('is-open'));
  let lastFocused = null;

  const syncExpanded = (triggers, isOpen) => triggers.forEach(trigger => trigger.setAttribute('aria-expanded', String(isOpen)));
  const syncBodyLock = () => {
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    body.classList.toggle('overflow-hidden', panelIsOpen(cartDrawer) || panelIsOpen(mobileMenu) || Boolean(searchDialog?.open));
  };
  const focusPanel = panel => {
    const preferred = panel?.querySelector('[data-cart-close], [data-menu-close], input, button, a[href]');
    window.requestAnimationFrame(() => preferred?.focus());
  };
  const setPanelState = (panel, isOpen) => {
    if (!panel) return;
    if (isOpen) lastFocused = document.activeElement;
    panel.classList.toggle('is-open', isOpen);
    panel.setAttribute('aria-hidden', String(!isOpen));
    if (panel.matches('[data-cart-drawer]')) syncExpanded(cartTriggers(), isOpen);
    if (panel.matches('[data-mobile-menu]')) syncExpanded(menuTriggers(), isOpen);
    syncBodyLock();
    if (isOpen) focusPanel(panel);
    if (!isOpen && lastFocused instanceof HTMLElement) lastFocused.focus();
  };
  const setSearchState = isOpen => {
    if (!searchDialog) return;
    if (isOpen) lastFocused = document.activeElement;
    if (isOpen && !searchDialog.open) searchDialog.showModal();
    if (!isOpen && searchDialog.open) searchDialog.close();
    syncExpanded(searchTriggers(), isOpen);
    syncBodyLock();
    if (isOpen) focusPanel(searchDialog);
    if (!isOpen && lastFocused instanceof HTMLElement) lastFocused.focus();
  };
  const refreshCartDrawer = async () => {
    const response = await fetch(`${productRoutes.cart}?section_id=cart-drawer-section`, { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('Unable to refresh the bag');
    const markup = await response.text();
    const replacement = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-cart-drawer]');
    if (!replacement) throw new Error('Updated bag could not be rendered');
    cartDrawer?.replaceWith(replacement);
    cartDrawer = replacement;
    const count = replacement.querySelector('[data-cart-count]')?.textContent?.trim() || '0';
    cartCount().forEach(element => { element.textContent = count; });
    return replacement;
  };
  const addToCart = async form => {
    const response = await fetch(productRoutes.add, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' }, body: new URLSearchParams(new FormData(form)) });
    if (!response.ok) throw new Error('Unable to add this product');
    return refreshCartDrawer();
  };
  const changeLine = async (key, quantity) => {
    const response = await fetch(productRoutes.change, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if (!response.ok) throw new Error('Unable to update this item');
    return refreshCartDrawer();
  };

  document.addEventListener('click', async event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('[data-menu-open]')) { setPanelState(document.querySelector('[data-mobile-menu]'), true); return; }
    if (target.closest('[data-menu-close]')) { setPanelState(document.querySelector('[data-mobile-menu]'), false); return; }
    if (target.closest('[data-cart-open]')) { setPanelState(cartDrawer, true); return; }
    if (target.closest('[data-cart-close]')) { setPanelState(cartDrawer, false); return; }
    if (target.closest('[data-search-open]')) { setSearchState(true); return; }
    if (target.closest('[data-search-close]')) { setSearchState(false); return; }
    const lineControl = target.closest('[data-line-increase], [data-line-decrease], [data-line-remove]');
    if (lineControl) {
      const line = lineControl.closest('[data-cart-line]');
      const currentQuantity = Number(line?.querySelector('.quantity-control span')?.textContent || 0);
      const key = line?.getAttribute('data-key');
      if (!key) return;
      const quantity = lineControl.matches('[data-line-increase]') ? currentQuantity + 1 : lineControl.matches('[data-line-decrease]') ? Math.max(0, currentQuantity - 1) : 0;
      lineControl.setAttribute('aria-busy', 'true');
      try { const updatedDrawer = await changeLine(key, quantity); setPanelState(updatedDrawer, true); }
      catch { const items = cartDrawer?.querySelector('[data-cart-items]'); if (items) items.insertAdjacentHTML('afterbegin', '<p class="form-error" role="alert">Your bag could not be updated. Please try again.</p>'); }
      finally { lineControl.removeAttribute('aria-busy'); }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[data-add-to-cart]');
    const label = button?.querySelector('[data-add-label]') || button;
    const status = form.querySelector('[data-product-status]');
    if (button) button.disabled = true;
    if (label) label.textContent = 'Adding…';
    if (status) status.textContent = '';
    try { const updatedDrawer = await addToCart(form); setPanelState(updatedDrawer, true); }
    catch { if (status) status.textContent = 'This product could not be added. Please try again.'; }
    finally { if (button) button.disabled = false; if (label) label.textContent = 'Add to bag'; }
  });
  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const quantityControl = target.closest('.quantity-control');
    if (!quantityControl || target.closest('[data-line-increase], [data-line-decrease]')) return;
    const input = quantityControl.querySelector('input[type="number"]');
    if (!input) return;
    if (target.closest('[data-quantity-decrease], [data-cart-page-decrease]')) input.value = String(Math.max(1, Number(input.value) - 1));
    if (target.closest('[data-quantity-increase], [data-cart-page-increase]')) input.value = String(Number(input.value) + 1);
  });
  document.addEventListener('keydown', event => {
    const activePanel = searchDialog?.open ? searchDialog : panelIsOpen(cartDrawer) ? cartDrawer : panelIsOpen(document.querySelector('[data-mobile-menu]')) ? document.querySelector('[data-mobile-menu]') : null;
    if (event.key === 'Tab' && activePanel) {
      const focusable = [...activePanel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary')].filter(item => item.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0]; const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      return;
    }
    if (event.key === 'Escape') {
      if (searchDialog?.open) { setSearchState(false); return; }
      if (panelIsOpen(cartDrawer)) { setPanelState(cartDrawer, false); return; }
      setPanelState(document.querySelector('[data-mobile-menu]'), false);
    }
  });
  searchDialog?.addEventListener('close', () => { syncExpanded(searchTriggers(), false); syncBodyLock(); });
  const variantsData = document.querySelector('[data-product-variants]');
  const productForm = document.querySelector('[data-product-form]');
  if (variantsData && productForm) {
    const variants = JSON.parse(variantsData.textContent);
    const idInput = productForm.querySelector('[data-variant-id]');
    const priceWrap = document.querySelector('[data-product-price]');
    const status = productForm.querySelector('[data-product-status]');
    const addButton = productForm.querySelector('[data-add-to-cart]');
    const addLabel = addButton?.querySelector('[data-add-label]') || addButton;
    const syncVariant = () => {
      const selectedValues = [...productForm.querySelectorAll('.product-option input:checked')].map(input => input.value);
      const variant = variants.find(item => item.options.every((option, index) => option === selectedValues[index]));
      if (!variant) return;
      idInput.value = variant.id;
      const price = (variant.price / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
      if (priceWrap) priceWrap.innerHTML = `<div class="price"><span class="price__regular">${price}</span></div>`;
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (status) status.textContent = variant.available ? 'Available now' : 'This selection is currently unavailable.';
    };
    productForm.querySelectorAll('.product-option input').forEach(input => input.addEventListener('change', syncVariant));
  }
})();

(() => {
  document.querySelectorAll('[data-gallery-stage]').forEach(stage => {
    const gallery = stage.closest('.product__gallery');
    if (!gallery) return;
    const slides = [...stage.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const prevButton = gallery.querySelector('[data-gallery-prev]');
    const nextButton = gallery.querySelector('[data-gallery-next]');
    if (slides.length < 2) return;

    const activeIndex = () => Math.round(stage.scrollLeft / stage.clientWidth);
    const setActive = index => {
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === index);
        thumb.setAttribute('aria-selected', String(thumbIndex === index));
      });
    };
    const goTo = index => {
      const clamped = Math.max(0, Math.min(slides.length - 1, index));
      stage.scrollTo({ left: stage.clientWidth * clamped, behavior: 'smooth' });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => goTo(index)));
    prevButton?.addEventListener('click', () => goTo(activeIndex() - 1));
    nextButton?.addEventListener('click', () => goTo(activeIndex() + 1));

    let ticking = false;
    stage.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setActive(activeIndex());
        ticking = false;
      });
    });
    window.addEventListener('resize', () => goTo(activeIndex()));
  });
})();
